import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { debounceTime, merge, startWith } from 'rxjs';
import { cloneDeep } from 'lodash-es';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { Utilities } from '@core/helpers/utilities';

export const setDatiBilancioBisDataChiusuraListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_DataChiusura1_2(form, store);
};

const my_DataChiusura1_2 = (form: FormGroup, store: Store<Revisione53State>): void => {
    const datiBilancioGroup = getGroup(form, 'my_SezioneI__Rilevazione.my_DatiBilancio');
    const effettivitaBaseSocialeGroup = getGroup(form, 'my_SezioneI__Rilevazione.my_EffettivitaBaseSociale');

    const bilAnno1Control = getControl(datiBilancioGroup, 'my_BilAnno1');
    const bilAnno2Control = getControl(datiBilancioGroup, 'my_BilAnno2');
    const chiusuraEsercizioControl = getControl(effettivitaBaseSocialeGroup, 'my_ChiusuraEsercizio');

    merge(
        bilAnno1Control.valueChanges.pipe(startWith(bilAnno1Control.value)),
        bilAnno2Control.valueChanges.pipe(startWith(bilAnno2Control.value)),
        chiusuraEsercizioControl.valueChanges.pipe(startWith(chiusuraEsercizioControl.value))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            const dataChiusura1 = buildDataChiusura(bilAnno1Control.value, chiusuraEsercizioControl.value);
            const dataChiusura2 = buildDataChiusura(bilAnno2Control.value, chiusuraEsercizioControl.value);

            getControl(datiBilancioGroup, 'my_DataChiusura1').patchValue(dataChiusura1, { emitEvent: false });
            getControl(datiBilancioGroup, 'my_DataChiusura2').patchValue(dataChiusura2, { emitEvent: false });

            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);

                myVerbaleClone.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataChiusura1 = dataChiusura1;
                myVerbaleClone.my_SezioneI__Rilevazione.my_DatiBilancio.my_DataChiusura2 = dataChiusura2;

                return myVerbaleClone;
            });
        });
};

const buildDataChiusura = (bilAnno: string, chiusuraEsercizio: string): string => {
    const anno = bilAnno ?? '';
    const chiusura = chiusuraEsercizio ?? '';

    const separatore = chiusura.substring(2, 3);
    const mese = chiusura.substring(3, 5);
    const giorno = chiusura.substring(0, 2);

    return `${anno}${separatore}${mese}${separatore}${giorno}`;
};
